import { PERFORATION_CODE } from '@/components/WellLoggingOperations/Tablet/Flowmetry/constants';

/*
    Нормализация потокометрии для отрисовки в список, header и columns.

    Основная идея здесь - это сортировка.
    По идее, сортировку нужно проводить СРАЗУ после получения данных, но в ядре получения хаос.
    Сейчас происходит ТРИ сортировки для отображения в три разных компонента.

    * Так же здесь компонуются данные. Для каждого компонента свой НЕОБХОДИМЫЙ набор.

    TODO:
    Идеальный сценарий:
    - получаем данные
    - сортируем
    - раскидывает уже отсортированные данные по тем компонентам / моделям - где оны нужны
    
    ! Поэтому это решение лежит сбоку.
*/

class FlowmetryNormalize {
    _toDate(dateString) {
        const [day, month, year] = dateString.split('.').map(Number);
        return new Date(year, month - 1, day);
    }

    _sortByDate(data) {
        const sortedWell = data.slice().sort((item1, item2) => {
            return this._toDate(item1[1].header.date).getTime() - this._toDate(item2[1].header.date).getTime();
        });

        return sortedWell.map(([flowmetryId]) => flowmetryId);
    }

    _sortedFormat(wellFlowmetry, cb) {
        const flowmetry = Object.entries(wellFlowmetry);

        const ids = this._sortByDate(flowmetry);

        const info = {};

        for (const item of flowmetry) {
            const [flowmetryId, data] = item;

            info[flowmetryId] = cb(data);
        }

        return Array.from(ids, id => Object.assign({ id }, info[id]));
    }

    _getPerforationDate(perforations) {
        const date = perforations.find(perforation => perforation.res_date);

        if (!date) return null;

        return new Date(date.res_date).toLocaleDateString('ru-RU');
    }

    /*
        needed fields:
        - visible, date, roof, bottom
    */
    toList(wellFlowmetry) {
        return this._sortedFormat(wellFlowmetry, flowmetryItem => {
            const { header, firstColumn } = flowmetryItem;
            const { roof, bottom } = header;

            let resDate = null;

            if (firstColumn && firstColumn[PERFORATION_CODE]) {
                resDate = this._getPerforationDate(firstColumn[PERFORATION_CODE]);
            }

            return { visible: flowmetryItem.visible, date: header.date, roof, bottom, resDate };
        });
    }

    /*
        needed fields:
        - id, regimes, visible, aim, date  
    */
    toHeader(wellFlowmetry) {
        return this._sortedFormat(wellFlowmetry, flowmetryItem => {
            return { visible: flowmetryItem.visible, ...flowmetryItem.header };
        });
    }

    /*
        needed fields:
        - all
    */
    toColumns(wellFlowmetry) {
        return this._sortedFormat(wellFlowmetry, flowmetryItem => {
            return flowmetryItem;
        });
    }
}

/*
    Получить кол-во режимов.
    По умолчанию лучше возвращать 1.
*/
export const getSizeRegimes = regimes => {
    if (!regimes) return 1;
    return Array.isArray(regimes) && regimes.length > 0 ? regimes.length : 1;
};

export const flowmetryNormalize = new FlowmetryNormalize();
